import Component from '../core/Component'
import Flickity from 'flickity'
import enquire from 'enquire.js'
import { queries } from '../core/config'

export const STATES = {
    COMPACT: 'is-compact',
    OPEN: 'is-open'
}

export const EMITS = {
    SLIDE_SELECTED: 'selected',
    OPEN: 'open',
}

export default class ThumbnailList extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            slider: null,
            expandButton: null,
            items: []
        }

        this.enquireHandler = {
            match: () => {
                this.destroyFlickity()
            },
            unmatch: () => {
                if (!this.is(STATES.COMPACT)) {
                    this.createFlickity()
                }
            }
        }

        this.flickity = null
    }

    prepare() {
        enquire.register(queries.mediumUp, this.enquireHandler)

        this.ref.expandButton?.addEventListener('click', () => this.expand())

        this.element.addEventListener('click', this.handleClick)
    }

    destroy() {
        enquire.unregister(queries.mediumUp, this.enquireHandler)
    }

    handleClick = event => {
        const element = event.target.closest('[data-ref="item"]')

        const index = this.ref.items.findIndex(item => item === element)

        if (!~index) {
            return
        }

        this.emit(EMITS.SLIDE_SELECTED, {
            index
        })
    }

    createFlickity() {
        this.flickity = new Flickity(this.element, {
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'center',
            contain: true
        })
    }

    expand() {
        if (this.is(STATES.OPEN)) {
            return
        }

        this.element.classList.add(STATES.OPEN)

        this.element.classList.remove(STATES.COMPACT)

        this.emit(EMITS.OPEN)

        if (window.matchMedia(queries.mediumUp).matches) {
            return
        }

        this.createFlickity()
    }

    collapse() {
        this.destroyFlickity()
        this.element.classList.remove(STATES.OPEN)
        this.element.classList.add(STATES.COMPACT)
    }

    destroyFlickity() {
        this.flickity?.destroy()
    }

    select(index) {
        if (parseInt(index) > 3) {
            this.expand()
        }

        this.flickity?.select(index)
    }
}